
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship-from-storage-services",
      function () {
        return require("private-next-pages/ship-from-storage-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ship-from-storage-services"])
      });
    }
  